import { Link } from 'react-router-dom';

export default function Gallery() {
  const projects = [
    {
      image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/56af3dcab4b0c79f2407d7ad80cbcfbd.jpeg',
      category: 'Spa Inspired Bathroom',
      title: 'Spa Inspired Bathroom',
      slug: 'spa-inspired-bathroom',
    },
    {
      image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6b46caaf1cd883cf1307dbc4375bbce9.jpeg',
      category: 'Bathroom',
      title: 'Bathroom',
      slug: 'bathroom',
    },
    {
      image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/bbd1645db457b8f35c143a5d651b873c.jpeg',
      category: 'Shower',
      title: 'Shower',
      slug: 'shower',
    },
    {
      image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/738a4d5a587ef2ba6a74ad1dfea30f03.jpeg',
      category: 'Basement',
      title: 'Basement Renovation',
      slug: 'basement',
    },
    {
      image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/d025fe4cc0484d5595dcfb67cf704735.jpeg',
      category: 'Kitchen',
      title: 'Kitchen Renovation',
      slug: 'kitchen',
    },
    {
      image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/5bd444f6e80012b0e9c8d582b091676c.jpeg',
      category: 'Laundry Room',
      title: 'Laundry Room',
      slug: 'laundry-room',
    },
  ];

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              RECENT PROJECTS
            </h2>
            <p className="text-gray-600 text-xl">See Our Craftsmanship</p>
          </div>
          <Link
            to="/projects"
            className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap"
          >
            <span>View All Projects</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <Link
              key={index}
              to={`/gallery/${project.slug}`}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer block"
            >
              <div className="relative w-full h-96">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-all duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-300"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent pointer-events-none">
                <span className="inline-block bg-teal-600 text-white px-4 py-1 rounded-full text-sm font-semibold mb-2 whitespace-nowrap">
                  {project.category}
                </span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="text-center text-white">
                  <span className="text-xl font-semibold flex items-center justify-center space-x-2 whitespace-nowrap">
                    <span>See More</span>
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
